import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { AdminCompanyVerificationControllerService } from './api/adminCompanyVerificationController.service';
import { AdminFullVersionWaitingListControllerService } from './api/adminFullVersionWaitingListController.service';
import { AdminNotificationSenderControllerService } from './api/adminNotificationSenderController.service';
import { AdminPlatformStatsControllerService } from './api/adminPlatformStatsController.service';
import { AdminTransactionControllerService } from './api/adminTransactionController.service';
import { AnnouncementControllerService } from './api/announcementController.service';
import { AppDocumentControllerService } from './api/appDocumentController.service';
import { AppVersionControllerService } from './api/appVersionController.service';
import { AuthControllerService } from './api/authController.service';
import { CategoryControllerService } from './api/categoryController.service';
import { ClientAccountControllerService } from './api/clientAccountController.service';
import { ClientAnnouncementControllerService } from './api/clientAnnouncementController.service';
import { ClientCompanyControllerService } from './api/clientCompanyController.service';
import { ClientCouponControllerService } from './api/clientCouponController.service';
import { ClientCouponV2ControllerService } from './api/clientCouponV2Controller.service';
import { ClientLocationControllerService } from './api/clientLocationController.service';
import { ClientLocationV2ControllerService } from './api/clientLocationV2Controller.service';
import { ClientLoyaltyControllerService } from './api/clientLoyaltyController.service';
import { ClientLoyaltyProgramV2ControllerService } from './api/clientLoyaltyProgramV2Controller.service';
import { ClientNotificationControllerService } from './api/clientNotificationController.service';
import { ClientPromotionControllerService } from './api/clientPromotionController.service';
import { ClientTransactionControllerService } from './api/clientTransactionController.service';
import { CompanyControllerService } from './api/companyController.service';
import { ConsoleCompaniesV2ControllerService } from './api/consoleCompaniesV2Controller.service';
import { ConsoleDashboardV2ControllerService } from './api/consoleDashboardV2Controller.service';
import { ConsoleNotificationV2ControllerService } from './api/consoleNotificationV2Controller.service';
import { ConsoleVerificationV2ControllerService } from './api/consoleVerificationV2Controller.service';
import { CouponControllerService } from './api/couponController.service';
import { CustomerLoyaltyControllerService } from './api/customerLoyaltyController.service';
import { FullVersionWaitingListControllerService } from './api/fullVersionWaitingListController.service';
import { KeywordControllerService } from './api/keywordController.service';
import { LiveFeedControllerService } from './api/liveFeedController.service';
import { LocationControllerService } from './api/locationController.service';
import { LoyaltyProgramControllerService } from './api/loyaltyProgramController.service';
import { LoyaltySetupControllerService } from './api/loyaltySetupController.service';
import { NotificationControllerService } from './api/notificationController.service';
import { PromotionControllerService } from './api/promotionController.service';
import { PromotionMetaControllerService } from './api/promotionMetaController.service';
import { PublicBrowseControllerService } from './api/publicBrowseController.service';
import { PublicControllerService } from './api/publicController.service';
import { PublicSocialNetworkPostControllerService } from './api/publicSocialNetworkPostController.service';
import { PublicV2ControllerService } from './api/publicV2Controller.service';
import { ReportControllerService } from './api/reportController.service';
import { ScanControllerService } from './api/scanController.service';
import { SocialNetworkPostsControllerService } from './api/socialNetworkPostsController.service';
import { StaffCouponActionControllerService } from './api/staffCouponActionController.service';
import { SystemStatusControllerService } from './api/systemStatusController.service';
import { TransactionControllerService } from './api/transactionController.service';
import { UserControllerService } from './api/userController.service';
import { ValueExtractorControllerService } from './api/valueExtractorController.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class ApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<ApiModule> {
        return {
            ngModule: ApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
